import gql from "graphql-tag";

const SUB_UNRESPONDED_COUNT = gql`
    subscription formSubmissionCount($division_id: Int){
        formSubmissionCount(division_id: $division_id)
    }
`;

export default SUB_UNRESPONDED_COUNT;
